import { useInstanceWorkspaceContext } from "../context/instance-workspace-context"
import { useIsRealInstance } from "./use-is-real-instance"

export function useDashboardLoadFailed(dashboardId: string | null): boolean {
  const instanceWorkspace = useInstanceWorkspaceContext()
  const isRealInstance = useIsRealInstance(dashboardId)
  const seed = instanceWorkspace?.currentSeed
  return isRealInstance && seed != null && !seed.loadSucceeded
}
